// le but de cette classe est de formater un fichier .data en json spécifique QCM pour le mettre dans une activity
// il permet aussi de relire ce json et de le manipuler côté react

import { action, computed, makeObservable, observable } from "mobx"
import { pickRandom } from "../utils"
import { STATES } from "./ActivityPedaInstance"

import Notifications from "../Notifications/Notifications"
import { TYPES } from "./ActivitiesConverter"
import ActivityPedaInstance from "./ActivityPedaInstance"
import ActivityResult from "./ActivityResult"


class Choice {
  ID
  Text = ""
  media
  selected = false
  locked = false

  isCorrect = false

  constructor(json, observe) {
    Object.assign(this, json)
    if(observe) this.observe()
  }

  observe() {
    makeObservable(this, {
      Text: observable,
      media: observable,
      isCorrect: observable,
      selected: observable,
      locked: observable,
      state: computed,
      setSelected: action
    })
  }

  setSelected(val) {
    this.selected = val
  }

  get state() {
    if(this.isCorrect && this.selected) return STATES.CORRECT
    if(!this.isCorrect && this.selected) return STATES.WRONG
    if(this.isCorrect && !this.selected) return STATES.MISSED
    return null

  }

}


// représente une seule question, avec ses choices et debriefs
export class QCM extends ActivityPedaInstance {


  /** @type {Array<Choice>} */
  choices = []

  QrlAnswer = "" // TODO se débarrasser de ça

  constructor(row) {
    super()
    Object.assign(this, row)
    // NOTE : parfois on ne le veut pas observable, quand on l'utilise depuis la classe QCMFile
  }

  fromJson(json) {
    Object.assign(this, json)
    this.choices = this.choices.map(c => new Choice(c, true))
    this.observe()
    return this
  }

  observe() {
    super.observe()
    makeObservable(this, {
      choices: observable,
      selectedChoices: computed
    })
  }

  addChoice(json, observe=false) {
    this.choices.push(new Choice(json, observe))
  }


  handleJauges(jauges) {
    // on regarde les réponses qu'on a cochées
    this.choices.filter(c => c.selected).forEach(c => {
      // si elles ont une info de jauge

      if(c.jauge) {
        try {
          let jauge_obj = JSON.parse(c.jauge)
          Object.keys(jauge_obj).forEach(jauge_id => {
            let success = jauges.increment(jauge_id, jauge_obj[jauge_id])
            if(!success) Notifications.error("Erreur colonne 'jauge' pour le QCM " + this.ID + " : cette id de jauge n'existe pas dans 'jauge.data' : " + jauge_id)
          })
        }
        catch(err) {
          Notifications.error("Erreur colonne 'jauge' pour le QCM " + this.ID)
        }
      }

    })

  }
  localCorrect() {
    // ici on va créer nous même le "result" au lieu de l'attendre du serveur

    // c'est correct si pas de wrong ni de missed

    if(this.Type === TYPES.QCM) {

      let nb_user_correct = this.choices.filter(c => c.state === STATES.CORRECT).length
      let nb_wrong = this.choices.filter(c => c.state === STATES.WRONG).length
      let nb_missed = this.choices.filter(c => c.state === STATES.MISSED).length

      let cumulScore = nb_user_correct - nb_missed - nb_wrong
      if (cumulScore < 0)
        cumulScore = 0

      let nb_correct = this.choices.filter(c => c.isCorrect).length

      let result = new ActivityResult()

      if(nb_correct===0) //a vérifier
         result.normalized_score = 0
      else
        result.normalized_score =  cumulScore  / nb_correct;
      
      result.is_correct = result.normalized_score >= 0.99999

      this.setResult(result)
    }

    if(this.Type === TYPES.QRL) {
      let qrlAnswer = this.QrlAnswer

      if(!qrlAnswer) {
        let result = new ActivityResult()
        result.is_correct = false
        result.normalized_score = 0
        this.setResult(result)
        return
      }


      let answer = qrlAnswer.trim().toLowerCase()
      let correctAnswer = this.choices.find(c => {
        let choice_text = c.Text.trim().toLowerCase()
        return choice_text === answer

        // return c.Text.localeCompare(qrlAnswer.trim(), undefined, { sensitivity: 'base' }) === 0
      })

      let result = new ActivityResult()
      result.is_correct = correctAnswer !== undefined
      result.normalized_score = result.is_correct ? 1 : 0
      if(correctAnswer) result.additionalInfos = { correctWord: correctAnswer.Text } // on renvoie le mot qui a matché, c'est pas forcément le premier
      this.setResult(result)
    }
  }

  get MultipleChoiceMode() {
    return this.choices.filter(c => c.isCorrect).length > 1
  }

  toggleChoice(choice) {

    if (choice.locked) return

    if(this.MultipleChoiceMode) {
      choice.setSelected(!choice.selected)
    }
    else {
      this.choices.forEach(c => c.setSelected(false))
      choice.setSelected(true)
    }
  }

  getAnswer() {
    return this.selectedChoicesIds
  }

  get selectedChoices() {
    return this.choices.filter(c => c.selected)
  }

  get unselectedChoices() {
    return this.choices.filter(c => !c.selected)

  }

  get selectedChoicesIds() {
    return this.selectedChoices.map(c => c.ID)
  }

  useJoker() {
    if(!this.jokerAvailable) return

    if(this.MultipleChoiceMode) {
      // on préselectionne un choice correct


      let c = pickRandom(this.choices.filter(c => c.isCorrect))
      c.selected = true
      c.locked = true
    }
    else {
      // on supprime un choice incorrect
      let c = pickRandom(this.choices.filter(c => !c.isCorrect))
      c.selected = false
      c.locked = true
    }

    this.jokerUsed = true
  }

  get jokerAvailable() {
    return this.choices.length > 2
  }


  getState() {
    let state = super.getState()
    if (this.Type === "qrl")
      state.QrlAnswer = this.QrlAnswer
    else if (this.Type === "question" || this.Type === "qcm" || this.Type === TYPES.QCM)
      state.choices = this.choices.map(c => {
        return { selected : c.selected, locked : c.locked }
      })
    return state
  }
  /**
   * Permet de remettre l'activité dans un état donné.
   * L'idée est de pouvoir reprendre l'activité dans un état bien précis via la sauvegarde ou autre chose, donc ça doit être
   * cohérent avec le fonctionnement de getState()
   */
  setState(state) {
    super.setState(state)
    if (this.Type === "qrl")
      this.QrlAnswer = state.QrlAnswer
    else if (this.Type === "question" || this.Type === "qcm" || this.Type === TYPES.QCM) {
      if(state.choices) {
        state.choices.forEach((c, index) => {
          let choice = this.choices[index]
          if (choice) {
            choice.selected = c.selected
            choice.locked = c.locked
          }
        })

      }
    }

  }

  reset() {
    this.setResult(null)
    this.QrlAnswer = ""
    this.choices.forEach(c => {
      c.selected = false
    })
  }




}


// représente tous les QCM
export class QCMFile {
  /** @type {Array<QCM>} */
  all = []

  constructor(json, file) {
    let current = null

    json.forEach(row => {
      try {
        if(row.Type === TYPES.QCM || row.Type === "question" || row.Type === "qcm" ||row.Type === "qrl") {
          current = this.makeQuestion(row)
          current.Type = row.Type === "qrl" ? TYPES.QRL : TYPES.QCM
          this.all.push(current)
        }

        if(row.Type === "choice") {
          current.addChoice(row)
        }

        if(row.Type === "debrief") {
          current.addDebrief(row, row.isCorrect)
        }

        if(row.Type === "debrief_correct") {
          current.addDebrief(row, true)
        }
        if(row.Type === "debrief_incorrect") {
          current.addDebrief(row, false)
        }
      }
      catch(err) {
        throw "ERREUR CREATION QCM : " + row.ID + " dans " + file
      }
    })

  }
  get(id) {
    return this.all.find(qcm => qcm.ID === id)
  }

  observeAll() {
    this.all.forEach(qcm=> {
      qcm.observe()
      makeObservable(qcm, { QrlAnswer: observable })
      qcm.choices.forEach(c=>c.observe())
      qcm.debriefs.forEach(d => d.observe())
    })
  }

  // allow overriding QCM
  makeQuestion(row) {
    return new QCM(row)
  }

  /**
   *
   * @param {QCM} qcm
   * @returns {Array}
   */
  static toDataRows(qcm) {
    // ici on voudrait générer les lignes pour le qcm

    let rows = []

    // ligne de question
    rows.push({
      ID: qcm.ID,
      Type: TYPES.QCM,
      Text: qcm.Text,
      media: qcm.media
    })

    // lignes de choices
    qcm.choices.forEach(c => {
      rows.push({
        ID: c.ID,
        Type: "choice",
        Text: c.Text,
        media: c.media,
        isCorrect: c.isCorrect
      })
    })
    // lignes de debriefs
    qcm.debriefs.forEach(d => {
      rows.push({
        ID: d.ID,
        Type: "debrief",
        Text: d.Text,
        media: d.media,
        isCorrect: d.isCorrect
      })
    })

    return rows
  }

}